import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
} from "reactstrap";

import Breadcrumbs from "../../components/common/Breadcrumb";

import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import { AxiosError, AxiosResponse } from "axios";
import { ApiCore } from "../../helpers/api_helper";
import { Endpoints } from "../../utils/Endpoints";
import {
  amountToCurrency,
  currentDate,
  dateToDbFormat,
  formattedDate,
  formatToDDMMYYHHMM,
  getCampuses,
  getForms,
  getTerms,
} from "../../utils/Helpers";
import { Link, useHistory, useLocation } from "react-router-dom";
import { invoiceEndDate, invoiceStartDate } from "../../utils/Helpers";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form, Formik } from "formik";
import { XSelect } from "../../components/common/inputs/XSelect";
import { XSearchableSelect } from "../../components/common/inputs/XSearchableSelect";
import { XTextBox } from "../../components/common/inputs/XTextBox";
import { ISelectOption } from "../../interfaces/inputs/ISelectOption";
import { XDatePickerField } from "../../components/common/inputs/XDatePickerField";
import { XCheckbox } from "../../components/common/inputs/XCheckbox";

const AttendanceList = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingSummary, setLoadingSummary] = useState<boolean>(false);
  const [message, setMessage] = useState<String>("");
  const [students, setStudents] = useState<number>(0);
  const [attendances, setAttendances] = useState<any>([]);
  const [initialValues, setInitialValues] = useState<any>({
    date: currentDate()
  });
  const [summary, setSummary] = useState<any>({});

  const history = useHistory();

  const request = new ApiCore();

  const fetchSummary = () => {
    setLoadingSummary(true);
    toast
      .promise(
        request.get(Endpoints.attendances, {
          params: {},
        }),
        {
          pending: "Please wait..",
          success: {
            render({ data }) {
              return "";
            },
          },
          error: {
            render({ data }) {
              return data;
            },
          },
        }
      )
      .then((response: AxiosResponse) => {
        setSummary(response.data)
        setLoadingSummary(false);
      })
      .catch((error) => {
        console.error(error);
        setLoadingSummary(false);
      });
  };

  const fetchRecords = (values: any) => {
    toast
      .promise(
        request.get(Endpoints.attendances, {
          params: {
            campus: values.campus,
            form: values.form,
            stream: values.stream,
            date: values.date,
          },
        }),
        {
          pending: "Please wait..",
          success: {
            render({ data }) {
              return "";
            },
          },
          error: {
            render({ data }) {
              return data;
            },
          },
        }
      )
      .then((response: AxiosResponse) => {
        const { students, attendances } = response.data;
        setAttendances(attendances);
        setStudents(students);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };


  const handleSubmit = (values: any) => {
    if (!values.campus || values.campus.length == 0 || !values.form || values.form.length == 0) {
      setInitialValues(values);
      setMessage("Campus and class must be provided");
    } else {
      setMessage("");
      fetchRecords(values);
    }
  };

  const onDelete = (id: number) => {
    if (window.confirm("Do you want to delete the record")) {
      request.delete(Endpoints.attendances + "/" + id).then((response: AxiosResponse) => {
        handleSubmit(initialValues);
      }).catch((error) => {
        toast.error(error);
      });
    }
  }

  useEffect(() => {
    fetchSummary()
  }, []);

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content">
        <MetaTags>
          <title>Attendance | Treda</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="View" breadcrumbItem="Marks" />
          <Row>
            <Col lg="12">
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <CardTitle className="h4">Attendance</CardTitle>

                  <UncontrolledDropdown className="mt-4 mt-sm-0">
                    <DropdownToggle tag="a" className="btn btn-light">
                      <i className="fa fa-ellipsis-v"></i>
                    </DropdownToggle>

                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem
                        to="#"
                        onClick={() => {
                          history.push("/marks/create");
                        }}
                      >
                        Upload Marks
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  {message.length > 0 && <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    <button type="button" className="close" aria-label="Close"><span aria-hidden="true">×</span>
                    </button>
                    <i className="uil uil-exclamation-octagon me-2"></i> {message}
                  </div>}
                  {!loading && (
                    <>
                      <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validateOnBlur
                        onSubmit={(values: any) => handleSubmit(values)}
                      >
                        {({
                          isSubmitting,
                          setFieldValue,
                          values,
                          errors,
                          touched,
                        }) => (
                          <>
                            <Form>
                              <Row>
                                <Col lg={3}>
                                  <XSelect
                                    key="campus"
                                    id="campus"
                                    name={"campus"}
                                    options={getCampuses()}
                                    label={"Campus"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <XSelect
                                    key="form"
                                    id="form"
                                    name={"form"}
                                    options={getForms(values.campus)}
                                    label={"Class"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XTextBox
                                    id="stream"
                                    type={"text"}
                                    name={"stream"}
                                    label={"Stream"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XDatePickerField
                                    key="date"
                                    id="date"
                                    name={"date"}
                                    label={"Date"}
                                    onChange={setFieldValue}
                                    value={values.date}
                                    touched={touched}
                                    errors={errors}
                                    showDateOnly={true}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <div>&nbsp;</div>
                                  <Button
                                    disabled={false}
                                    type="submit"
                                    className="btn btn-primary"
                                  >
                                    Next
                                  </Button>
                                </Col>
                              </Row>

                            </Form>
                            <hr />
                          </>
                        )}
                      </Formik>
                    </>
                  )}
                  <Row>

                    {attendances.length > 0 && <>
                      <Col md={7}>
                        <table className="table">
                          <thead>
                            <tr><th>Student</th><th>Date/Time</th><th>User</th><th></th></tr>
                          </thead>
                          <tbody>
                            {attendances.map((record: any) => {
                              return <tr key={record.id}>
                                <td>{record.studentInfo}</td>
                                <td>{formatToDDMMYYHHMM(record.created_at)}</td>
                                <td>{record.user.name}</td>
                                <td><a href="#" onClick={() => { onDelete(record.id) }} className="red"><i className="fa fa-trash"></i> Delete</a></td>
                              </tr>
                            })}
                          </tbody>
                        </table>
                        <hr />
                        <div><b>SUMMARY:</b> {attendances.length} of {students}</div>
                      </Col>
                    </>}
                    {summary && <>
                      <Col md={5}>
                        {Object.keys(summary).map((campus: string) => {
                          return <>
                            <b>{campus}</b><br />
                            <table className="table align-middle table-nowrap table-centered mb-0">
                              <thead>
                                <tr>
                                  <th><b>Class</b></th>
                                  <th><b>Stream</b></th>
                                  <th><b>Attendance</b></th>
                                </tr>
                                {Object.keys(summary[campus]).map((form: string) => {
                                  return Object.keys(summary[campus][form]).map((stream: string) => {
                                    return <tr>
                                      <td>{form}</td>
                                      <td>{stream}</td>
                                      <td>{summary[campus][form][stream].present} / {summary[campus][form][stream].total}</td>
                                    </tr>
                                  })
                                })}
                              </thead>
                            </table>
                          </>
                        })}
                      </Col>
                    </>}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AttendanceList;
